module.exports = {
  cofactors: [ 'atp', 'adp', 'nad', 'nadh', 'nadp', 'nadph', 'gtp', 'gdp',
  'h', 'coa', 'ump', 'h2o', 'ppi' ]
}



// WEBPACK FOOTER //
// ./src/Consts.js